// extracted by mini-css-extract-plugin
export default {"container":"mL-z","error":"nL-z","disabled":"oL-z","submit":"pL-z","option":"qL-z","success":"rL-z","failure":"sL-z"};